export default __webpack_public_path__ + "static/our-philosophy-hero-d71143802b276c85cdef69948d796cc1.jpg";